import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import {Button, Card, Col, Form, Input, QRCode, Row, Table, Tag, Tabs, Popconfirm} from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";
import Colors from "../../styles/Colors";
import {BiAlarm, BiAlarmOff, BiPencil, BiPlus, BiQr, BiRefresh, BiTrash, BiWorld} from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import {User} from "../../model/root/User";
import {GetUsuaris} from "../../dao/root/GetUsuaris";
import ControlHorari from "../../model/root/ControlHorari";
import controlHorari from "../../model/root/ControlHorari";
import {GetControlHorari} from "../../dao/root/GetControlHorari";
import ControlHorariAdminModal from "./components/ControlHorariModalAdmin";
import {PostControlHorari} from "../../dao/root/PostControlHorari";
import {format} from "date-fns";
import QrModal from "../root/component/QrModal";
import LlocTreball from "../../model/root/LlocTreball";
import {GetLlocTreball} from "../../dao/root/GetLlocTreball";
import {VscGraph} from "react-icons/vsc";
import LlocDeTreballModal from "../root/component/LlocDeTreballModal";
import Login from "../root/Login";
import LlocsTreball from "../admin/LlocsTreballAdmin";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {CheckUser} from "../../dao/root/CheckUser";
import toast, {Toaster} from "react-hot-toast";
import {useForm} from "antd/es/form/Form";
import {GetEmpresas} from '../../dao/admin/GetEmpresas';
const { TabPane } = Tabs;

const ControlHorariAdmin = () => {
    const titol: string = "Control Horari";
    const nomPermis: string = "Control Horari";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [options, setOptions] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);
    const [options2, setOptions2] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    const [coleccio, setDades] = useState<ControlHorari[]>([]);
    const [coleccio2, setDades2] = useState<LlocTreball[]>([]);
    const [usuaris, setUsuaris] = useState<User[]>([]);
    const [elementSelected, setElementSelected] = useState<ControlHorari>(new ControlHorari());
    const [llocSelected, setLlocSelected] = useState<LlocTreball>(new LlocTreball());
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [qrValue, setQrValue] = useState('');
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [visible2, setVisible2] = useState(false);
    const [qrVisible, setQrVisible] = useState(false);
    const [update, setUpdate] = useState(false);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [nouLloc, setNouLloc] = useState(false);
    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    const [coleccioControlHorari, setDadesControlHorari] = useState<controlHorari[]>([]);

    const typeColors: { [key: string]: string } = {
        'artiesport.ambittec.com': 'cyan',
        'mentsinquietes.ambittec.com': 'lime',
        'ambitescola.ambittec.com': 'pink',
    };
    useEffect(() => {
        handleLoadingChange(true)
        if (isLoggedIn) {
            if (permisosEdicio) {
                checkDades();
                checkDades2();
            }
            if (permisVisualitzacio) {

            }
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        setQrValue('');
         // Obtener empresas
        const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
        setDadesEmpresa(dadesEmpresas);

        const controlHorariTotals: any[] = [];
        const llocTreballTotals: any[] = [];
        
        for (const empresa of dadesEmpresas) {
            const datasource = empresa.datasource; 
            try {
                const dades = await GetControlHorari(datasource, '');
                const controlHorariEmpresa = (dades as any[]).map((controlHorari: any) => ({
                    ...controlHorari,
                    empresa: datasource
                }));

                const dadesLloc = await GetLlocTreball(datasource);
                const llocTreballEmpresa = (dadesLloc as any[]).map((lloctreball: any) => ({
                    ...lloctreball,
                    empresa: datasource
                }));

                controlHorariTotals.push(...controlHorariEmpresa);
                llocTreballTotals.push(...llocTreballEmpresa);

            } catch (error) {
                console.error(`Error obteniendo datos de la empresa ${datasource}`, error);
            }
        }
        //await checkDades2();
        const usuaris = await GetUsuaris(page);
        setUsuaris(usuaris.usuaris);
        
        setDadesControlHorari(controlHorariTotals);
        setLlocsOptions(llocTreballTotals);
        setUsuarisOptions(usuaris.usuaris);
        //setNameFilters(dades);
        handleLoadingChange(false);
    }

    async function checkDades2() {
        const dades = await GetLlocTreball(page);
        setLlocsOptions(dades);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    function setUsuarisOptions(usuaris: User[]) {
        if (usuaris && usuaris?.length) {
            const options = usuaris.map(contact => ({
                label: `${contact.nom}`,
                value: contact.id + ""
            }));
            setOptions(options);
        }
    }

    function setLlocsOptions(llocs: LlocTreball[]) {
        if (llocs && llocs?.length) {
            const options = llocs.map(lloc => ({
                label: `${lloc.nom}`,
                value: lloc.id + ""
            }));
            setOptions2(options);
        }
    }

    function afegirElement(element: ControlHorari) {
        setNouElement(!nouElement);
        setUpdate(false);
        setElementSelected(element);
    }

    function togleNouElement(element: ControlHorari) {
        setNouElement(!nouElement);
        setUpdate(true);
        
        setElementSelected(element);
    }

    async function desactivarElement(element: ControlHorari) {
        const modified: controlHorari = {
            ...element,
            estat: (element.estat === 0 ? 1 : 0)
        };
        await PostControlHorari(modified, element.empresa);
        checkDades();
    }

    async function deleteElement(element: ControlHorari) {
        const modified: controlHorari = {
            ...element,
            estat: -1
        };
        await PostControlHorari(modified, element.empresa);
        checkDades();
    }

    function handleCloseModal(value: boolean) {
         if (value){
            toast.success("GUARDAT");
            checkDades();
        }
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    const handleLoadingChange2 = (enable: boolean) => {
        setLoading2(enable);
    };

    function setNameFilters(elements: ControlHorari[]) {
        const ControlHorariNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ControlHorariNames);
    }

    function showEstadistiques(ele: ControlHorari) {
        navigate("/controlhorari/"+ele.id_usuario+'/'+ele.empresa);
    }

    const columns: ColumnsType<ControlHorari> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Nom usuari',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'entrada',
            title: 'Entrada',
            dataIndex: 'entrada',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color1}>{ele.entrada+""}</Tag>
            )
        },
        {
            key: 'sortida',
            title: 'Sortida',
            dataIndex: 'sortida',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{ele.sortida+""}</Tag>
            )
        },
        {
            key: 'lloc',
            title: 'Lloc de treball',
            dataIndex: 'lloc',
            width: 30,
            render: (estat, ele) =>(
                (ele.lloc === 'Itinerant' && <Tag color={Colors.colors.color4}>{ele.lloc}</Tag>) || (ele.lloc !== 'Itinerant' && ele.lloc)
            )

        },
        {
            key: 'empresa',
            title: 'Empresa',
            dataIndex: 'empresa',
            width: '15%',
            render: (name: string) => (
                    <Tag color={typeColors[name]}>
                        {name}
                    </Tag>
                ),
          
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 140,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Invalidar"} style={ele.estat === 0 ? {backgroundColor: Colors.colors.color3}
                                : {backgroundColor: Colors.colors.color1}}
                                    onClick={() => desactivarElement(ele)}>{ele.estat === 0 ? <BiAlarmOff/> :
                                <BiAlarm/>}</Button>{" "}
                            <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color4}}
                                    onClick={() => togleNouElement(ele)}><BiPencil/></Button>{" "}
                           {" "}
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>  
                            {" "}
                            <Button title={"Estadístiques"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => showEstadistiques(ele)}><VscGraph/></Button>
                        </>
                    )}
                </>
            ),
        },
    ];

    const tableProps: TableProps<ControlHorari> = {
        loading
    };

    const onChange: TableProps<ControlHorari>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    function QRGenerator() {
        setQrVisible(true);
    }

    function handleCloseQr() {
        setQrVisible(false);
    }

    const getFormattedDate = () => {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1; // Los meses en JavaScript son base 0, así que agregamos 1
        const year = today.getFullYear();

        // Asegurémonos de que los valores tengan dos dígitos
        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;

        return `${formattedDay}-${formattedMonth}-${year}:${userId}`;
    };

    async function handleLlocModalClose(element: LlocTreball, guardar: boolean) {
        setNouLloc(false);
        if (guardar) {
            setLoading2(true);
            //await PostControlHorari(element, page);
            await checkDades2();
            await checkDades();
        }
    }
    async function deleteLloc(element: LlocTreball) {
        const modified: LlocTreball = {
            ...element,
            estat: -1
        };
        handleLlocModalClose(element, true);
    }

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {/* {permisosEdicio && */}
                                {/* <> */}
                                    <Button title={"Nou Control Horari"} style={{backgroundColor: Colors.colors.color2}}
                                            onClick={() =>
                                                afegirElement(new ControlHorari())}><BiPlus/></Button>
                                    {" "}
                                    <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                        checkDades()}><BiRefresh/></Button>
                                    {" "}
                                {/* </> */}
                            {/* } */}
                                <Button title={"Mostrar QR"} style={{backgroundColor: Colors.colors.color6}}
                                        onClick={() => QRGenerator()}><BiQr/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && permisosEdicio && (
                            <Tabs defaultActiveKey="tots" type="card">
                                <TabPane tab="Tots" key="tots">
                                    <Table
                                        {...tableProps}
                                        rowKey={(record) => `${record.empresa}-${record.id}`}
                                        onChange={onChange}
                                        columns={columns}
                                        dataSource={coleccioControlHorari}
                                    />
                                </TabPane>
                                {/* Tabs dinámicos por empresa */}
                                {empresas.map((empresa: any) => (
                                    <TabPane tab={empresa.nomEmpresa} key={empresa.datasource}>
                                        <Table
                                            {...tableProps}
                                            rowKey={(record) => `${record.empresa}-${record.id}`}
                                            onChange={onChange}
                                            columns={columns}
                                            dataSource={coleccioControlHorari.filter(control => control.empresa === empresa.datasource)}
                                        />    
                                    </TabPane>
                                ))}
                            </Tabs>
                            

                        )}
                        { permisVisualitzacio && (
                            <QrModal visible={qrVisible} content={''} onClose={handleCloseQr} />
                        )}
                    </Card>
                    <br/>
                    { permisosEdicio && <LlocsTreball />}
                    <br/>
                    { permisosEdicio && <Historials pantalla={"CONTROLHORARI"} pagina={page}/>}
                    {nouElement && (
                        <ControlHorariAdminModal element={elementSelected} onClose={handleCloseModal}
                                            visible={nouElement}  
                                            update={update} />
                    )}
                    {qrVisible && (
                        <QrModal visible={qrVisible} onClose={handleCloseQr} content={getFormattedDate()}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login />
        );
    }
};
export default ControlHorariAdmin;
